module.exports = __webpack_public_path__ + "static/media/trillio_medium.a8a40a90.jpg";